import React, { useState, useEffect } from "react";

import { Row, Col } from "../../UI/Customstrap/Customstrap";
import { TitleLabel } from "../../UI/TitleLabel/TitleLabel";
import { formattedNumber } from "../../FormattedNumber/FormattedNumber";
import { Icons } from "../../UI/Icon/Icon";

import style from "./Summary.scss";
import { CircularProgress } from "../../UI/CircularProgress/CircularProgress";

export const Summary = ({ portfolio }) => {
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (portfolio) {
      setTotal(+portfolio.positionUSD.portfolioTotalUSD);
    }
  }, [portfolio]);

  if (!portfolio) return <CircularProgress />;

  return (
    <Row>
      <Col>
        <Row>
          <Col xs={12}>
            <TitleLabel className={style.titleSummary} label="Resumen" />
          </Col>
          <Col xs={12}>
            <div className={style.fx}>
              <span className={style.fxLabel}>Cambio actual:</span>
              <span>{`Gs ${formattedNumber(portfolio.currencypairprice.rawprice, 0, 0)}`}</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6} xl={12}>
            <div className={style.totals}>
              <span className={style.title}>En efectivo</span>
              <div className={style.currencyTotal}>
                <Icons.USDIcon size="md" className={style.currencyIcon} />
                <div className={style.balanceWrapper}>
                  <span className={style.currencyISO}>USD</span>
                  <span className={style.balance}>{formattedNumber(portfolio.position.cashTotal, 2, 2)}</span>
                </div>
              </div>
              <div className={style.currencyTotal}>
                <Icons.PYGIcon size="md" className={style.currencyIcon} />
                <div className={style.balanceWrapper}>
                  <span className={style.currencyISO}>Gs</span>
                  <span className={style.balance}>
                    {formattedNumber(portfolio.positionPYG.cashTotal, 0, 0)}
                  </span>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={6} xl={12}>
            <div className={style.totals}>
              <span className={style.title}>En valores</span>
              <div className={style.currencyTotal}>
                <Icons.USDIcon size="md" className={style.currencyIcon} />
                <div className={style.balanceWrapper}>
                  <span className={style.currencyISO}>USD</span>
                  <span className={style.balance}>
                    {formattedNumber(portfolio.position.valueTotalUSD, 2, 2)}
                  </span>
                </div>
              </div>
              <div className={style.currencyTotal}>
                <Icons.PYGIcon size="md" className={style.currencyIcon} />
                <div className={style.balanceWrapper}>
                  <span className={style.currencyISO}>Gs</span>
                  <span className={style.balance}>
                    {formattedNumber(portfolio.positionPYG.portfolioTotal, 0, 0)}
                  </span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className={style.total}>
              <hr className={style.totalDivider} />
              <span className={style.totalLabel}>Total*</span>
              <span className={style.totalBalace}>
                <span className={style.totalBalaceISO}>USD</span>
                <span className={style.totalBalanceNumber}>{formattedNumber(total, 2, 2)}</span>
              </span>
              <span className={style.disclaimer}>*Valorizado en dólares</span>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
